import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5e64a910&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=5e64a910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64a910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e64a910')) {
      api.createRecord('5e64a910', component.options)
    } else {
      api.reload('5e64a910', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=5e64a910&scoped=true&", function () {
      api.rerender('5e64a910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/_poll/details.vue"
export default component.exports